import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
/**
 * `Service` The naming standards service
 */
var NamingStandards = /*#__PURE__*/function (_Base) {
  /**
   * Create the naming standards service instance.
   *
   * @param sdk - the SDK instance
   */
  function NamingStandards(sdk) {
    _classCallCheck(this, NamingStandards);
    return _callSuper(this, NamingStandards, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(NamingStandards, _Base);
  return _createClass(NamingStandards, [{
    key: "getNamingStandards",
    value: (
    /**
     * Get the naming standards of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/2f05842a18599-get-naming-standards
     *
     * @param projectId -  the project id.
     * @param query -  the query with the shape of \{ fields, filter[ids], offset, limit, sort \}.
     * @param config - the object to overwrite request parameters.
     */
    function () {
      var _getNamingStandards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, query, config) {
        var urlQuery, url, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              urlQuery = QS.stringify(query, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/naming-standards").concat(urlQuery);
              _context.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getNamingStandards(_x, _x2, _x3) {
        return _getNamingStandards.apply(this, arguments);
      }
      return getNamingStandards;
    }()
    /**
     * Get the naming standard of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/e4702a59f34f8-get-naming-standard-by-id
     *
     * @param projectId -  the project id.
     * @param namingStandardId - the naming standard id.
     * @param query -  the query with the shape of \{ fields \}.
     * @param config - the object to overwrite request parameters.
     */
    )
  }, {
    key: "getNamingStandard",
    value: (function () {
      var _getNamingStandard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, namingStandardId, query, config) {
        var urlQuery, url, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              urlQuery = QS.stringify(query, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/naming-standards/").concat(namingStandardId).concat(urlQuery);
              _context2.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getNamingStandard(_x4, _x5, _x6, _x7) {
        return _getNamingStandard.apply(this, arguments);
      }
      return getNamingStandard;
    }()
    /**
     * Create the naming standard of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/0400e93786e65-create-naming-standards
     *
     * @param projectId -  the project id.
     * @param query -  the query.
     * @param namingStandard - the naming standard.
     * @param config - the object to overwrite request parameters.
     */
    )
  }, {
    key: "createNamingStandard",
    value: (function () {
      var _createNamingStandard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId) {
        var query,
          namingStandard,
          config,
          urlQuery,
          res,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              namingStandard = _args3.length > 2 ? _args3[2] : undefined;
              config = _args3.length > 3 ? _args3[3] : undefined;
              urlQuery = QS.stringify(query, {
                addQueryPrefix: true
              });
              _context3.next = 6;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/naming-standards").concat(urlQuery), namingStandard, config);
            case 6:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createNamingStandard(_x8) {
        return _createNamingStandard.apply(this, arguments);
      }
      return createNamingStandard;
    }()
    /**
     * Update the naming standard of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/eae03c5bc67b6-update-naming-standard-by-schema
     *
     * @param projectId -  the project id.
     * @param namingStandardId - the naming standard id.
     * @param query -  the query.
     * @param namingStandard - the namingStandard.
     * @param config - the object to overwrite request parameters.
     */
    )
  }, {
    key: "updateNamingStandard",
    value: (function () {
      var _updateNamingStandard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, namingStandardId) {
        var query,
          namingStandard,
          config,
          urlQuery,
          res,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              namingStandard = _args4.length > 3 ? _args4[3] : undefined;
              config = _args4.length > 4 ? _args4[4] : undefined;
              urlQuery = QS.stringify(query, {
                addQueryPrefix: true
              });
              _context4.next = 6;
              return this.HttpService.dmV3.put("/projects/".concat(projectId, "/naming-standards/").concat(namingStandardId).concat(urlQuery), namingStandard, config);
            case 6:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateNamingStandard(_x9, _x10) {
        return _updateNamingStandard.apply(this, arguments);
      }
      return updateNamingStandard;
    }()
    /**
     * Remove the naming standard of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/e88a28afb5147-delete-naming-standard-by-id
     *
     * @param projectId -  the project id.
     * @param namingStandardId - the naming standard id.
     * @param query -  the query.
     * @param config - the object to overwrite request parameters.
     */
    )
  }, {
    key: "removeNamingStandard",
    value: (function () {
      var _removeNamingStandard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, namingStandardId, query, config) {
        var urlQuery, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              urlQuery = QS.stringify(query, {
                addQueryPrefix: true
              });
              _context5.next = 3;
              return this.HttpService.dmV3["delete"]("/projects/".concat(projectId, "/naming-standards/").concat(namingStandardId).concat(urlQuery), config);
            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function removeNamingStandard(_x11, _x12, _x13, _x14) {
        return _removeNamingStandard.apply(this, arguments);
      }
      return removeNamingStandard;
    }()
    /**
     * Get the locked status of the naming standard
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1242e99488053-get-naming-standard-locked-status
     *
     * @param projectId -  the project id.
     * @param namingStandardId - the naming standard id.
     * @param query -  the query.
     * @param config - the object to overwrite request parameters.
     */
    )
  }, {
    key: "getLockedStatus",
    value: (function () {
      var _getLockedStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, namingStandardId, query, config) {
        var urlQuery, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              urlQuery = QS.stringify(query, {
                addQueryPrefix: true
              });
              _context6.next = 3;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/naming-standards/").concat(namingStandardId, "/locked-status").concat(urlQuery), config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getLockedStatus(_x15, _x16, _x17, _x18) {
        return _getLockedStatus.apply(this, arguments);
      }
      return getLockedStatus;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'NamingStandards';
    }
  }]);
}(Base);
export default NamingStandards;